module.exports = __webpack_public_path__ + "img/user2.c0c5dab3.png";